import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormatter'
})
export class PhoneFormatterPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.match(/\+/) ? value : '+'+value;
  }

}
